import React from "react";
import InputMask from "react-input-mask";
import { withTranslation, useTranslation } from "react-i18next";
import { isEmpty } from "lodash";

const Card = (props) => {
  const { t } = useTranslation();
  const cardNumberHandler = (e) => {
    if (e) {
      const result = e.target.value.replaceAll("-", "");
      const returnObj = { name: "cardNumber", value: result };
      props.handleChange({ target: returnObj });
    }
  };

  const expirationHandler = (e) => {
    if (e) {
      const result = e.target.value.replaceAll("/", "");
      const returnObj = { name: "expMmYy", value: result };
      props.handleChange({ target: returnObj });
    }
  };

  return (
    <div id="card-info" className="flex flex-col justify-center pt-5">
      <div className="flex flex-col mb-12">
        <p
          className="type-title small text-okkami-husk mb-6"
          style={{ color: props.backgroundColorTopBar }}
        >
          CARDHOLDER NAME
        </p>
        <input
          type="text"
          name="cardholderName"
          value={props.getCardholderName}
          onChange={props.handleChange}
          className="capitalize border-b w-full px-4 rounded-none outline-none focus:outline-none type-normal large md:mb-10"
          style={{ borderColor: "#C1C1C1", minHeight: "38px" }}
        />
        {!props.validate && isEmpty(props.getCardholderName) && (
          <p className="text-14 text-red-500 mt-5">
            {t(
              "PLEASE_FILL_OUT_REQUIRED",
              "Please fill all the required fields"
            )}
          </p>
        )}
      </div>

      <div className="flex flex-col mb-12">
        <p
          className="type-title small text-okkami-husk mb-6"
          style={{ color: props.backgroundColorTopBar }}
        >
          CARD NUMBER
        </p>
        <InputMask
          mask="9999-9999-9999-9999"
          name="cardNumber"
          value={props.getCardNumber}
          onChange={cardNumberHandler}
          className="capitalize border-b w-full px-4 rounded-none outline-none focus:outline-none type-normal large md:mb-10"
          style={{ borderColor: "#C1C1C1", minHeight: "38px" }}
        />
        {!props.validate && isEmpty(props.getCardNumber) && (
          <p className="text-14 text-red-500 mt-5">
            {t(
              "PLEASE_FILL_OUT_REQUIRED",
              "Please fill all the required fields"
            )}
          </p>
        )}
      </div>

      <div className="flex flex-wrap mb-12">
        <div className="w-1/2 pr-4">
          <p
            className="type-title small text-okkami-husk mb-6"
            style={{ color: props.backgroundColorTopBar }}
          >
            CVC/CCV
          </p>
          <input
            type="text"
            name="cvcCcv"
            value={props.getCvcCcv}
            onChange={props.handleChange}
            maxLength="4"
            className="capitalize border-b w-full px-4 rounded-none outline-none focus:outline-none type-normal large md:mb-10"
            style={{ borderColor: "#C1C1C1", minHeight: "38px" }}
          />
          {!props.validate && isEmpty(props.getCvcCcv) && (
            <p className="text-14 text-red-500 mt-5">
              {t(
                "PLEASE_FILL_OUT_REQUIRED",
                "Please fill all the required fields"
              )}
            </p>
          )}
        </div>

        <div className="w-1/2 pl-4">
          <p
            className="type-title small text-okkami-husk mb-6"
            style={{ color: props.backgroundColorTopBar }}
          >
            EXP MMYY
          </p>
          <InputMask
            mask="99/99"
            name="expMmYy"
            value={props.getExpMmYy}
            onChange={expirationHandler}
            className="capitalize border-b w-full px-4 rounded-none outline-none focus:outline-none type-normal large md:mb-10"
            style={{ borderColor: "#C1C1C1", minHeight: "38px" }}
          />
          {!props.validate && isEmpty(props.getExpMmYy) && (
            <p className="text-14 text-red-500 mt-5">
              {t(
                "PLEASE_FILL_OUT_REQUIRED",
                "Please fill all the required fields"
              )}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(Card);
